export default __webpack_public_path__ + "static/media/CN.5f48ee19.png";